import React, { useState } from "react";
import Section from "../../sections/Section/Section";
import UseCaseSwitch from "./UseCaseSwitch";
import classes from "./UseCaseSwitchSection.module.css";
import { getUseCases, shouldUseAn } from "./helpers";
import { navigate } from "gatsby";

function UseCaseSwitchSection({ title, subtitle }) {
  const [useCase, setUseCase] = useState();

  function goToUseCase() {
    if (!useCase) return;
    navigate(`/${useCase.id}`);
  }

  return (
    <Section className={classes.useCaseSwitch} innerClassName={classes.inner}>
      <div className={classes.wrapper}>
        <h1>I am {shouldUseAn(useCase) ? "an" : "a"}</h1>
        <UseCaseSwitch
          options={getUseCases()}
          value={useCase}
          onChange={setUseCase}
        />
        <button
          onClick={goToUseCase}
          className={classes.button}
          disabled={!useCase}
        >
          Go!
        </button>
      </div>
    </Section>
  );
}

export default UseCaseSwitchSection;
